import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mountain, BoxIcon, X } from 'lucide-react';
interface Tab {
  id: string;
  label: string;
  icon: BoxIcon;
}
interface SidebarProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (id: string) => void;
  isMobileOpen?: boolean;
  onClose?: () => void;
}
export function Sidebar({
  tabs,
  activeTab,
  onTabChange,
  isMobileOpen = false,
  onClose
}: SidebarProps) {
  const handleTabChange = (id: string) => {
    onTabChange(id);
    if (onClose) onClose();
  };
  const sidebarContent = <>
      {/* Branding */}
      <div className="p-6 flex items-center justify-between" style={{
      borderBottom: '1px solid #2a3d52'
    }} data-id="element-584">
        <div className="flex items-center gap-3" data-id="element-585">
          <img src="https://cdn.magicpatterns.com/uploads/tBhnFXTTHsdeeAqgdiSXBp/fais-logo-transparent.png" alt="ФАіСУ" className="w-10 h-10 rounded-xl object-contain flex-shrink-0" data-id="element-586" />
          <div data-id="element-587">
            <h1 className="font-bold text-[16px]" style={{
            color: '#ffffff'
          }} data-id="element-588">
              ФАіСУ
            </h1>
          </div>
        </div>
        {onClose && <button onClick={onClose} className="md:hidden p-2 rounded-lg text-slate-400 hover:bg-white/10 transition-colors" data-id="element-589">
            <X className="w-5 h-5" data-id="element-590" />
          </button>}
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-5 px-3 space-y-0.5" data-id="element-591">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = tab.id === activeTab;
        return <button key={tab.id} onClick={() => handleTabChange(tab.id)} className="relative w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group" style={{
          color: isActive ? '#ffffff' : '#94b8cc',
          backgroundColor: isActive ? 'rgba(59,143,212,0.18)' : 'transparent'
        }} onMouseEnter={e => {
          if (!isActive) (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'rgba(255,255,255,0.06)';
        }} onMouseLeave={e => {
          if (!isActive) (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'transparent';
        }} data-id="element-592">
              <Icon className="w-5 h-5 flex-shrink-0 transition-colors" style={{
            color: isActive ? '#3b8fd4' : '#7fb3d3'
          }} data-id="element-593" />
              <span className="flex-1 text-left" data-id="element-594">{tab.label}</span>
            </button>;
      })}
      </nav>
    </>;
  return <>
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex flex-col w-64 h-screen sticky top-0 z-40" style={{
      backgroundColor: '#1e2d3d',
      borderRight: '1px solid #2a3d52'
    }} data-id="element-595">
        {sidebarContent}
      </aside>

      {/* Mobile Sidebar Overlay */}
      <AnimatePresence data-id="element-596">
        {isMobileOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="md:hidden fixed inset-0 z-50 bg-black/50" onClick={onClose} data-id="element-597" />
            <motion.aside initial={{
          x: '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '-100%'
        }} transition={{
          duration: 0.25,
          ease: [0.2, 0.65, 0.3, 0.9]
        }} className="md:hidden fixed inset-y-0 left-0 z-50 flex flex-col w-72" style={{
          backgroundColor: '#1e2d3d'
        }} data-id="element-598">
              {sidebarContent}
            </motion.aside>
          </>}
      </AnimatePresence>
    </>;
}